import React, { Component } from 'react';
import { withFormik } from 'formik';
import Yup from 'yup';
import T from 'i18n-react';
import DonationChooser from './DonationChooser';
import TextInput from './TextInput';
import RadioButton from './RadioButton';
import paypalImg from '../assets/img/paypal.svg';

export default class PaymentForm extends Component {
  render() {
    return <MyEnhancedForm {...this.props} showSuccessInfo={this.props.showSuccessInfo} />
  }
}

const donationErr = <T.span text={{key: "donationErr"}} />;

const formikEnhancer = withFormik({
  initialValues: {
    donationDetails:{
      address: "",
      postalCode: "",
      city: "",
      country: "",
      contactOption: "By e-mail",
      email: "",
      furtherInformation: false
    },
    paymentDetails: {
      passengerLastName: "",
      passengerFirstName: "",
      bic: "",
      iban: "",
      paypalID: ""
    }
  },

  validationSchema: (props) => Yup.object().shape({
  donation: Yup.number()
    .typeError(donationErr)
    .required(donationErr)
    .positive(donationErr)
    .max(Number(props.data.paxToTransferAmount), donationErr),
  donationDetails: Yup.object().when('donation', {
    is: (donation) => {return donation > 0},
    then: Yup.object().shape({
      address: Yup.string().required(<T.span text={{key: "addressErr"}} />),
      postalCode: Yup.string().required(<T.span text={{key: "postalCodeErr"}} />),
      city: Yup.string().required(<T.span text={{key: "cityErr"}} />),
      country: Yup.string().required(<T.span text={{key: "countryErr"}} />),
      email: Yup.string().email(<T.span text={{key: "emailErr"}} />).required(<T.span text={{key: "emailErr"}} />),
    })
  }),
  paymentOption: Yup.string(),
  paymentDetails: Yup.object().when('paymentOption', {
    is: (paymentOption) => {return paymentOption === "Bank transfer"},
    then: Yup.object().shape({
      passengerLastName: Yup.string()
        .required(<T.span text={{key: "lastName"}} />),
      passengerFirstName: Yup.string()
        .required(<T.span text={{key: "firstName"}} />),
      bic: Yup.string()
        .required(<T.span text={{key: "bicErr"}} />),
      iban: Yup.string()
        .required(<T.span text={{key: "ibanErr"}} />),
    }),
    otherwise: Yup.object().shape({
      paypalID: Yup.string()
        .email(<T.span text={{key: "paypalErr"}} />)
        .required(<T.span text={{key: "paypalErr"}} />),
      })
    }),
  }),
  mapPropsToValues: (props) => ({
    donation: 0,
    donationDetails:{
      address: "",
      postalCode: "",
      city: "",
      country: "",
      contactOption: "By e-mail",
      email: props.data.passengerTicket.passengerEmail,
      furtherInformation: false
    },
    paymentOption: "Bank transfer",
    paymentDetails: {
      passengerLastName: props.data.passengerTicket.passengerLastName,
      passengerFirstName: props.data.passengerTicket.passengerFirstName,
      bic: "",
      iban: "",
      paypalID: ""
    }
  }),
  handleSubmit: (values, { props, setSubmitting }) => {
    const claim = {
      donatedAmount : String(values.donation),
      paxBankAccountHolder : values.paymentDetails.passengerFirstName + ' ' + values.paymentDetails.passengerLastName,// are u sure??!?!!?!?!?
      bicSwift : values.paymentDetails.bic,
      iban : values.paymentDetails.iban,
      paxPaypalId : values.paymentDetails.paypalID,
      taxReceiptReceptionMethod : values.donationDetails.contactOption,
      paxTransferChannel: values.paymentOption
    }
    const passengerTicket = {
      mailingStreet: values.donationDetails.address,
      mailingPostalCode: values.donationDetails.postalCode,
      mailingCity: values.donationDetails.city,
      mailingCountry: values.donationDetails.country,
      donationEmail: values.donationDetails.email,
      optOutFromOngInfo: String(values.donationDetails.furtherInformation)
    }

    const input = {
      claim: claim,
      passengerTicket
    }
    
    props.handleSubmit(input)
  },
  displayName: "MyForm"
});

class MyForm extends Component {
  showSuccessInfo=()=>{
    if(this.props.isValid){
      if(typeof this.props.showSuccessInfo === 'function'){
        this.props.showSuccessInfo(true)
      }
    }
  }
  selectedDonation=(donation, e)=>{
    if(!isNaN(Number(donation)) && donation!==""){
      donation = Number(donation);
    }
    this.props.setFieldValue('donation', donation)
  }

  showDonationDetails=(value)=>{
    const {
      values,
      touched,
      errors,
      handleChange,
      handleBlur
    } = this.props;
    const {
      passengerTicket: { passengerEmail },
      paxToTransferAmount,
      charity: { name }
    } = this.props.data
    const totalValueForClient = Number(paxToTransferAmount) - Number(values.donation);
    const donationDetails = values.donationDetails || {}
    const touchedDonationDetails =touched.donationDetails || {};
    const errorsDonationDetails =errors.donationDetails || {};
    if(Number(value)!==0){
      return (
        <div>
          <div className="user-data">
            <span className="user-data__info">
              {T.translate("secondStatement", {
                charity: name
              })}<br/>
              {(totalValueForClient)>=0 ? T.translate("thirdStatement", {
                finalCompensation: totalValueForClient
              }) :
              T.translate("thirdStatement", {
                finalCompensation: 0
              })}
            </span>
            <div className="user-data__box">
              <div className="user-address">
                <span className="user-address__info">
                  {T.translate("addressHeader")}
                </span>
                <div className="user-address__fields">
                  <TextInput
                    style={{width: "225px"}}
                    id="donationDetails.address"
                    type="text"
                    label={T.translate("address")}
                    placeholder={T.translate("addressHint")}
                    error={touchedDonationDetails.address && errorsDonationDetails.address}
                    value={values.address}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <TextInput
                    style={{width: "96px"}}
                    id="donationDetails.postalCode"
                    type="text"
                    label={T.translate("postcode")}
                    placeholder="00000"
                    error={touchedDonationDetails.postalCode && errorsDonationDetails.postalCode}
                    value={values.postalCode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <TextInput
                    style={{width: "162px"}}
                    id="donationDetails.city"
                    type="text"
                    label={T.translate("city")}
                    placeholder={T.translate("cityHint")}
                    error={touchedDonationDetails.city && errorsDonationDetails.city}
                    value={values.city}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <TextInput
                    style={{width: "162px"}}
                    id="donationDetails.country"
                    type="text"
                    label={T.translate("country")}
                    placeholder={T.translate("countryHint")}
                    error={touchedDonationDetails.country && errorsDonationDetails.country}
                    value={values.country}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </div>
              </div>
                <div className="payment-chooser">
                  <RadioButton
                    id="donationDetails.contactByPostalAdderss"
                    name="donationDetails.contactOption"
                    type="radio"
                    label={T.translate("postalRadio")}
                    value="By post"
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <RadioButton
                    id="donationDetails.contactByEmail"
                    name="donationDetails.contactOption"
                    type="radio"
                    defaultChecked={true}
                    label={T.translate("emailRadio")}
                    value="By e-mail"
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </div>
                <div className="email-box">
                  <div className="email">
                    <TextInput
                      id="donationDetails.email"
                      type="email"
                      label={T.translate("email")}
                      placeholder={passengerEmail}
                      error={touchedDonationDetails.email && errorsDonationDetails.email}
                      value={donationDetails.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                  <div className="further-information">
                    <RadioButton
                      id="donationDetails.furtherInformation"
                      name="donationDetails.furtherInformation"
                      type="checkbox"
                      label={T.translate("unsubscribe", {
                          charity: name
                      })}
                      value={values.furtherInformation}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
  }
  render(){
    const {
      values,
      touched,
      errors,
      handleChange,
      handleBlur,
      handleSubmit,
      isSubmitting
    } = this.props;
    const {
      passengerTicket: {passengerFirstName, passengerLastName},
      paxToTransferAmount,
      charity,
      affiliate
    } = this.props.data;
    const paymentDetails =values.paymentDetails || {};
    const touchedPaymentDetails =touched.paymentDetails || {};
    const errorsPaymentDetails =errors.paymentDetails || {};
    const totalValueForClient = Number(paxToTransferAmount) - Number(values.donation);
    let sepa;
    let paypal;

    if(affiliate.paypal){
      sepa = <RadioButton
        id="sepa"
        name="paymentOption"
        defaultChecked={true}
        type="radio"
        label={T.translate("sepaLine")}
        value="Bank transfer"
        onChange={handleChange}
        onBlur={handleBlur}
      />
      paypal = <section>
        <div className="container-internal">
          <div className="paypal">
            <RadioButton
              id="paypal"
              name="paymentOption"
              type="radio"
              label={T.translate("paypalCheckbox", {
                paypal: <img className="logo-scheneider" src={paypalImg} alt="paypal logo"/>
              })}
              value="PayPal"
              onChange={handleChange}
              onBlur={handleBlur}
            />
            <div className="form-frame">
              <div>
                <div className="form__row">
                  <TextInput
                    id="paymentDetails.paypalID"
                    type="text"
                    label={T.translate("paypalInput")}
                    error={touchedPaymentDetails.paypalID && errorsPaymentDetails.paypalID}
                    value={values.paypalID}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </div>
                {((values.paymentOption)==="PayPal")&&
                  (<div className="paypal-info">
                    {T.translate("paypalBody")}
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </section>
    } else {
      sepa = <span>{T.translate("sepaLine")}</span>
    }
    return (
      <section>
        <form onSubmit={handleSubmit}>
          {charity && <div className="donation-main">
            <div className="donation__chooser container-internal">
              <span className="donation__chooser__info">
                {T.translate("statement", {
                  charity: charity.name,
                  donation: values.donation
                })}
              </span>
              <DonationChooser
                onDonationChange={this.selectedDonation}
                touched={touched.donation}
                error={errors.donation}
                value={values.donation}
              />
              {this.showDonationDetails(values.donation)}
            </div>
          </div>}

          <div>
            <div className="container-internal">
              <div className="payment">
                <h2>{T.translate("paymentDetailsHeader")}</h2>
                <p>
                    {(totalValueForClient)>=0 ? T.translate("paymentDetailsBody", {
                      finalCompensation: totalValueForClient
                    }) :
                    T.translate("paymentDetailsBody", {
                      finalCompensation: 0
                    })}
                </p>
                {sepa}
                <div className="form-frame">
                  <div>
                    <div className="form__row">
                      <TextInput
                        id="paymentDetails.passengerLastName"
                        type="text"
                        label={T.translate("lastName")}
                        placeholder={passengerLastName}
                        error={touchedPaymentDetails.passengerLastName && errorsPaymentDetails.passengerLastName}
                        value={paymentDetails.passengerLastName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <TextInput
                        id="paymentDetails.passengerFirstName"
                        type="text"
                        label={T.translate("firstName")}
                        placeholder={passengerFirstName}
                        error={touchedPaymentDetails.passengerFirstName && errorsPaymentDetails.passengerFirstName}
                        value={paymentDetails.passengerFirstName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </div>
                    <div className="form__row">
                      <TextInput
                        id="paymentDetails.iban"
                        type="text"
                        label={T.translate("iban")}
                        error={touchedPaymentDetails.iban && errorsPaymentDetails.iban}
                        value={paymentDetails.iban}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <TextInput
                        id="paymentDetails.bic"
                        type="text"
                        label={T.translate("swiftBIC")}
                        error={touchedPaymentDetails.bic && errorsPaymentDetails.bic}
                        value={paymentDetails.bic}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {paypal}
          <div className="valider">
            <button
              // onClick={this.showSuccessInfo}
              type="submit"
              name="submit"
              className="btn"
              disabled={isSubmitting}>
              {T.translate("signButton")}
            </button>
          </div>
        </form>
      </section>
    )
  }
}

const MyEnhancedForm = formikEnhancer(MyForm);



// WEBPACK FOOTER //
// ./src/components/PaymentForm.js